import type { ReactNode } from "react";

export interface ScreenContentProps {
  children?: ReactNode;
}

/**
 * CRTScreen.Content - Container for main UI content
 *
 * Place as a sibling to CRTScreen.Background and CRTScreen.Footer inside CRTScreen.Root.
 * Content will be rendered on top of the background layer.
 *
 * @example
 * ```tsx
 * <CRTScreen.Root>
 *   <CRTScreen.Background>...</CRTScreen.Background>
 *   <CRTScreen.Content>
 *     <MyUIContent />
 *   </CRTScreen.Content>
 *   <CRTScreen.Footer />
 * </CRTScreen.Root>
 * ```
 */
export function ScreenContent({ children }: ScreenContentProps) {
  // This component is a marker - its children are extracted by CRTScreen.Root
  return <>{children}</>;
}
